export function createTextStyleStateFields(position) {
  const inheritFromState = this.parent.state.fields.at(position)
  const initValue = this.parent.state.value[inheritFromState.key]

  this.state.update({
    ...inheritFromState,
    value: initValue ?? inheritFromState.value ?? null
  })
}

export function applyDemoStyles() {
  const {
    fontWeight,
    letterWidth,
    italic,
    lineHeight,
    fontFamily,
    letterSpacing,
    fontSize
  } = this.state.value
  const variations = ['"wght"', '"wdth"']
  const variationValues = [fontWeight, letterWidth]
  const fontFamilyValues =
    fontFamily && fontFamily !== 'inherit'
      ? this.getDesignSystem('font_family')[fontFamily].value.join(', ')
      : 'inherit'

  const textPreview = this.lookdown('Demo')

  textPreview?.setNodeStyles({
    fontVariationSettings: variationValues
      .map((v, i) => {
        if (!v) {
          return null
        }

        return `${variations[i]} ${v}`
      })
      .filter((v) => v)
      .join(', '),
    fontFamily: fontFamilyValues,
    letterSpacing: `${letterSpacing}em`,
    fontStretch: `${letterWidth}em`,
    lineHeight,
    fontWeight,
    fontStyle: italic ? `oblique ${italic / 10}deg` : null
  })
  textPreview?.update({
    fontSize
  })
}

export function extractLetterFromVar(input) {
  // Usando regex com grupo de captura nomeado para extrair a letra e o número
  const match = input?.match(/--font-size-(?<letter>[A-Z])(?<number>\d+)?\)/u)

  // Retorna a letra capturada se encontrada, caso contrário retorna null
  return match ? match.groups.letter + (match.groups.number || '') : null
}
